
import initWeb3 from './initWeb3';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { setUserBalance } from '@/store';
const useUserBalance = () => {
    const { address } = useSelector(state => state.home)
    const { userBalance } = useSelector(state => state.home)
    const dispatch = useDispatch()
    const getBalance = initWeb3(async (address) => {
        const balance = await getCardIndex(address)
        console.log('balancebalance:', balance)
        return parseInt(balance/1000000000000000000)
         
    })
    const getCardIndex = async (address) => {
        return window.contract.methods.balanceOf(address).call()
    }
    const updateUserBalance = async (exp) => {
        let expires = exp || new Date(new Date() * 1 + 24 * 60 * 60 * 1000)
        const balance = await getBalance(address)
        console.log('balance:',balance)
        Cookies.set('balance', balance, { expires })
        dispatch(setUserBalance(balance))
    }
    return {
        userBalance,
        updateUserBalance,
    }
}

export default useUserBalance;